import { ContestApi } from '../api-typings/contests/contests';
import { transformCurrency } from '../currency/currency.transformers';
import { Contest } from './contest.model';

export function transformContest(contest: ContestApi): Contest {
  if (
    !contest.currency ||
    !contest.owner_id ||
    !contest.seo_url ||
    !contest.status ||
    !contest.type
  ) {
    throw new ReferenceError(`Missing a required contest field.`);
  }

  return {
    id: contest.id,
    currency: transformCurrency(contest.currency),
    description: contest.description || '',
    jobs: contest.jobs || [],
    ownerId: contest.owner_id,
    seoUrl: contest.seo_url,
    status: contest.status,
    title: contest.title || '',
    type: contest.type,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/contest/contest.transformers.ts